
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import GoogleAnalytics from '../components/GoogleAnalytics';



function Outstationcabservice() {



  const cardData =
  {
    keyword: 'Outstation Cabs Pune',
    heading: 'SHREE Tours & Travels: Outstation Cabs Pune',
    headingDescription: 'SHREE Tours & Travels offers reliable Outstation Cabs from Pune, providing a comfortable and hassle-free travel experience to popular destinations like Mumbai, Nashik, Shirdi, Mahabaleshwar, Kolhapur, Goa and more. Whether you are traveling for business, leisure, or pilgrimage, our well-maintained Cabs and professional drivers ensure a safe and smooth journey. With on-time pickups, flexible booking options and affordable fares, we make outstation travel convenient and stress-free. Choose SHREE Tours & Travels for the best outstation Cab service from Pune.',

    top: 'Top Places to Visit in Pune with SHREE Tours & Travels',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A historic fortification in Pune, Shaniwar Wada was once the seat of the Peshwas of the Maratha Empire. Built in 1732, this grand structure features intricate wooden architecture, massive gates and the famous 'Delhi Darwaza.' It is surrounded by gardens and fountains, making it a great spot for history enthusiasts. The light and sound show in the evening narrates the fort's rich history, adding to the experience."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is an architectural masterpiece and a symbol of India's freedom struggle. It served as a prison for Mahatma Gandhi and other freedom fighters during the Quit India Movement. The palace features Italian arches, sprawling gardens and a museum housing personal belongings of Mahatma Gandhi, making it a must-visit for history and heritage lovers."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Perched atop a hill, Sinhagad Fort is one of Pune’s most famous trekking destinations. This historic fortress, associated with the Maratha warrior Tanaji Malusare, offers breathtaking views of the Sahyadri mountains. Visitors can explore the ancient ruins, enjoy local delicacies like 'pithla bhakri,' and experience the fort’s rich history while trekking through its scenic trails."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of Pune’s most revered temples, Dagdusheth Halwai Ganpati Temple is dedicated to Lord Ganesha. Known for its grand Ganesh idol adorned with gold ornaments, the temple attracts thousands of devotees daily. The temple’s annual Ganesh festival is a grand spectacle, featuring magnificent decorations, cultural performances and a spiritual ambiance."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "A fascinating museum housing over 20,000 artifacts, the Raja Dinkar Kelkar Museum showcases a diverse collection of sculptures, paintings, musical instruments and everyday objects from India’s past. The museum is particularly known for its replica of the Mastani Mahal, which provides a glimpse into the royal lifestyle of the Peshwas."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "Carved out of a single rock in the 8th century, the Pataleshwar Cave Temple is dedicated to Lord Shiva. This ancient temple, featuring massive stone pillars and intricate carvings, is a peaceful retreat amidst Pune’s bustling city life. The temple’s unique architecture and serene atmosphere make it a hidden gem for history and spirituality seekers."
    },
    {
        "title": "Pashan Lake",
        "description": "Pashan Lake is a beautiful artificial lake, ideal for nature lovers and bird watchers. Surrounded by lush greenery, the lake serves as a habitat for various migratory birds. The walking track along the lake makes it a perfect spot for morning walks, photography and peaceful relaxation away from the city’s hustle."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a world-renowned spiritual center promoting meditation and wellness. Visitors can experience a range of meditation techniques, yoga sessions and rejuvenation therapies. The ashram's lush gardens, serene atmosphere and international community make it a unique place for self-discovery and relaxation."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal is a historic site closely associated with Chhatrapati Shivaji Maharaj, as it was his childhood residence. Though rebuilt, the palace features paintings and exhibits depicting Shivaji’s life and achievements. The site is of great historical importance and offers insights into the Maratha legacy."
    },
    {
        "title": "Khadakwasla Dam",
        "description": "Situated on the outskirts of Pune, Khadakwasla Dam is a popular picnic spot offering scenic views and a refreshing escape. The dam is a great place for photography, evening walks and enjoying street food like corn and chai. The nearby Sinhagad Fort and Panshet Dam make it a perfect getaway for adventure seekers and nature lovers."
    }
],  
    
            
"services": [
    {
      "name": "Outstation Cabs in Pune",
      "description": "Travel comfortably and affordably with our outstation Cabs from Pune. Whether you're heading to nearby cities or distant destinations, we provide reliable and well-maintained vehicles for a hassle-free journey."
    },
    {
      "name": "Pune to Outstation Taxi",
      "description": "Book a Cab from Pune to any outstation destination with ease. Our professional drivers ensure a smooth, safe and comfortable ride to your destination at affordable rates."
    },
    {
      "name": "Affordable Outstation Cab Service Pune",
      "description": "Get affordable outstation Cab services from Pune with SHREE Tours & Travels. Enjoy budget-friendly options without compromising on comfort, safety, or quality."
    },
    {
      "name": "Private Outstation Cabs from Pune",
      "description": "Enjoy privacy and comfort with our private outstation Cabs from Pune. Whether you're traveling for business or leisure, we offer personalized services tailored to your schedule and needs."
    },
    {
      "name": "Outstation Taxi Hire Pune",
      "description": "Looking to hire a taxi for your outstation trip from Pune? We offer a variety of vehicle options with professional drivers for a smooth and memorable journey to your destination."
    },
    {
      "name": "Pune to Mahabaleshwar Outstation Cab",
      "description": "Book an outstation Cab from Pune to Mahabaleshwar for a scenic and peaceful journey. Our comfortable vehicles and experienced drivers ensure a smooth ride to this beautiful hill station."
    },
    {
      "name": "Pune to Mumbai Outstation Taxi",
      "description": "Travel from Pune to Mumbai with ease using our outstation taxi service. Whether it's a one-way or round-trip ride, our professional drivers ensure a comfortable and timely journey to Mumbai."
    },
    {
      "name": "Group Travel Outstation Cab Pune",
      "description": "Traveling with a group? We offer spacious and comfortable outstation Cabs for group travel from Pune. Enjoy a shared journey with friends, family, or colleagues to your destination."
    },
    {
      "name": "Pune to Kolhapur Outstation Taxi",
      "description": "Plan a smooth and hassle-free trip from Pune to Kolhapur with our outstation taxi service. We offer affordable rates, well-maintained vehicles and experienced drivers for a comfortable journey."
    },
    {
      "name": "Book Outstation Cabs from Pune",
      "description": "Booking outstation Cabs from Pune has never been easier. Choose from a wide range of vehicles and enjoy a seamless experience with our reliable booking system and professional drivers."
    },
    {
      "name": "Reliable Outstation Cabs Pune",
      "description": "Count on us for reliable outstation Cab services from Pune. Our fleet of well-maintained vehicles and experienced drivers ensure your travel is safe, comfortable and punctual."
    },
    {
      "name": "Outstation Cab Rental Pune",
      "description": "Rent a Cab for your outstation trip from Pune with ease. Whether it's for a day or a week, we offer flexible rental options with professional drivers to ensure your journey is smooth and enjoyable."
    }
  ],
  "tableData": [
    ["- Outstation Cabs in Pune", "- Pune to Outstation Taxi"],
    ["- Affordable Outstation Cab Service Pune", "- Private Outstation Cabs from Pune"],
    ["- Outstation Taxi Hire Pune", "- Pune to Mahabaleshwar Outstation Cab"],
    ["- Pune to Mumbai Outstation Taxi", "- Group Travel Outstation Cab Pune"],
    ["- Pune to Kolhapur Outstation Taxi", "- Book Outstation Cabs from Pune"],
    ["- Reliable Outstation Cabs Pune", "- Outstation Cab Rental Pune"]
  ],


  
  whychoose: [
    {
      "WhyChooseheading": "Comfortable Long-Distance Travel",
      "WhyChoosedescription": "Our outstation Cabs in Pune are designed for long-distance travel, providing a comfortable, relaxing ride to your desired destination. Whether it's a business trip or a vacation, we ensure a smooth and enjoyable journey with spacious and well-maintained vehicles."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "We have a team of experienced and professional drivers who are well-versed with the best routes for outstation trips. Our drivers prioritize your safety, comfort and punctuality, ensuring a smooth and timely journey from Pune to your destination."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "SHREE Tours & Travels offers competitive and transparent pricing for outstation Cabs from Pune. Our rates are budget-friendly, with no hidden charges, so you can enjoy long-distance travel without worrying about unexpected costs."
    },
    {
      "WhyChooseheading": "Well-Maintained Vehicles",
      "WhyChoosedescription": "All our outstation vehicles are regularly serviced and maintained to ensure reliability and comfort. We provide a variety of vehicles, from sedans to SUVs, to cater to your travel needs, all equipped with modern amenities for a pleasant experience."
    },
    {
      "WhyChooseheading": "Flexible Travel Packages",
      "WhyChoosedescription": "We understand that different travelers have different needs. That's why we offer flexible outstation Cab packages tailored to your schedule. Whether you need a one-way trip or a round-trip, we can customize the journey to meet your preferences."
    },
    {
      "WhyChooseheading": "Seamless Booking Process",
      "WhyChoosedescription": "Booking an outstation Cab with SHREE Tours & Travels is quick and easy. You can make a reservation online through our user-friendly platform, or reach out to our customer service team for personalized assistance. We ensure a hassle-free booking experience every time."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "Our outstation Cab service is available 24/7, ensuring that you can book your ride at any time, day or night. Whether you’re traveling early in the morning or late at night, we’re ready to serve you with punctual and dependable service."
    },
    {
      "WhyChooseheading": "Customer Satisfaction Guarantee",
      "WhyChoosedescription": "Customer satisfaction is our top priority. We are committed to making your outstation trip from Pune as comfortable and enjoyable as possible. With our reliable service, you can count on us to provide a pleasant and hassle-free experience, every time."
    }
  ]
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  



        
  }
  const faqData = [
    {
        question: "How can I book an outstation Cab from Pune?",
        answer: "You can easily book your outstation Cab from Pune through our website or by calling our customer service for assistance."
    },
    {
        question: "What types of outstation Cabs are available in Pune?",
        answer: "We offer a variety of vehicles for outstation trips, including sedans, SUVs, MPVs and luxury cars, to suit your travel preferences and group size."
    },
    {
        question: "Are the rental rates for outstation Cabs from Pune inclusive of fuel?",
        answer: "Fuel charges may vary depending on the rental agreement. Detailed pricing information will be provided during the booking process."
    },
    {
        question: "Can I book an outstation Cab for a one-way trip from Pune?",
        answer: "Yes, we offer one-way rental options for outstation trips from Pune to various destinations."
    },
    {
        question: "Do you provide drivers with the outstation Cabs from Pune?",
        answer: "Yes, all our outstation Cabs come with experienced drivers who are familiar with long-distance routes to ensure a smooth and safe journey."
    },
    {
        question: "What is your cancellation policy for outstation Cab bookings from Pune?",
        answer: "We offer a flexible cancellation policy. Please contact us for detailed information specific to your booking."
    },
    {
        question: "What payment methods do you accept for outstation Cab bookings from Pune?",
        answer: "We accept various payment methods, including cash, credit/debit cards and mobile wallets for your convenience."
    },
    {
        question: "Are the outstation vehicles insured for safety during trips?",
        answer: "Yes, all our outstation vehicles are fully insured to ensure your safety and peace of mind during the journey."
    },
    {
        question: "Can I request a child seat for my outstation Cab from Pune?",
        answer: "Yes, child seats can be arranged upon request at the time of booking."
    },
    {
        question: "What is your contact information for booking an outstation Cab from Pune?",
        answer: "For bookings and inquiries, you can reach us at: +91 9594917913."
    }
];

const testimonialsData = [
    {
        text: 'I had a wonderful experience with SHREE Tours & Travels for an outstation trip from Pune. The driver was professional and the vehicle was clean and comfortable.',
        name: 'Mr. Rohit Patil',
    },
    {
        text: 'SHREE Tours & Travels offers the best outstation Cab service in Pune. The journey was smooth and the driver ensured we reached our destination safely and on time.',
        name: 'Miss. Snehal Shah',
    }
];













  
  
  


  


  const contactData = {
     heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9594917913",

    ],
    email: "booking@shreecabs24.com"
  };


    const Images = [
    {
        place: "/images/keyword/1.jpg",
        text: "Pune to Kolhapur Cab",
        link: "/Pune-to-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/2.jpg",
        text: "Pune to Mumbai Cab",
        link: "/Pune-to-Mumbai-Cab",
    },
    {
        place: "/images/keyword/3.jpg",
        text: "Pune to Sangli Cab",
        link: "/Pune-to-Sangli-Cab",
    },
    {
        place: "/images/keyword/4.jpg",
        text: "Pune to Mahabaleshwar Cab",
        link: "/Pune-to-Mahabaleshwar-Cab",
    },
    {
        place: "/images/keyword/5.jpg",
        text: "Pune to Bhimashankar Cab",
        link: "/Pune-to-Bhimashankar-Cab",
    },
    {
        place: "/images/keyword/6.jpg",
        text: "Pune to Shirdi Cab",
        link: "/Pune-to-Shirdi-Cab",
    },
    {
        place: "/images/keyword/7.jpg",
        text: "Pune to Nashik Cab",
        link: "/Pune-to-Nashik-Cab",
    },
    {
        place: "/images/keyword/8.jpg",
        text: "Pune Airport Pickup and Drop",
        link: "/Pune-Airport-Pickup-and-Drop",
    },
    {
        place: "/images/keyword/9.jpg",
        text: "Pune To Mumbai Airport Cab",
        link: "/Pune-To-Mumbai-Airport-Cab",
    },
    {
        place: "/images/keyword/10.jpg",
        text: "Mumbai To Pune Cab",
        link: "/Mumbai-To-Pune-Cab",
    },
    {
        place: "/images/keyword/12.jpg",
        text: "Mumbai To Kolhapur Cab",
        link: "/Mumbai-To-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/13.jpg",
        text: "Mumbai To Shirdi Cab",
        link: "/Mumbai-To-Shirdi-Cab",
    },
    {
        place: "/images/keyword/14.jpg",
        text: "Mumbai To Nashik Cab",
        link: "/Mumbai-To-Nashik-Cab",
    },
    {
        place: "/images/keyword/15.jpg",
        text: "Mumbai Airport To Pune Cab",
        link: "/Mumbai-Airport-To-Pune-Cab",
    },
    {
        place: "/images/keyword/16.jpg",
        text: "Kolhapur To Pune Cab",
        link: "/Kolhapur-To-Pune-Cab",
    },
    {
        place: "/images/keyword/17.jpg",
        text: "Kolhapur To Mumbai Cab",
        link: "/Kolhapur-To-Mumbai-Cab",
    },
    {
        place: "/images/keyword/18.jpg",
        text: "Sangli To Pune Cab",
        link: "/Sangli-To-Pune-Cab",
    },
    {
        place: "/images/keyword/19.jpg",
        text: "One Way Taxi in Pune",
        link: "/One-Way-Taxi-in-Pune",
    },
    {
        place: "/images/keyword/20.jpg",
        text: "Best Cab service in Pune",
        link: "/Best-Cab-Service-in-Pune",
    },
    {
        place: "/images/keyword/21.jpg",
        text: "Outstation Cabs Pune",
        link: "/Outstation-Cabs-Pune",
    },
    {
        place: "/images/keyword/22.jpg",
        text: "Swift Dzire Hire in Pune",
        link: "/Swift-Dzire-Hire-in-Pune",
    },
    {
        place: "/images/keyword/23.jpg",
        text: "Xcent Hyundai On Rent in Pune",
        link: "/Xcent-Hyundai-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/24.jpg",
        text: "Nexa Ciaz On Rent in Pune",
        link: "/Nexa-Ciaz-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/25.jpg",
        text: "Honda City On Rent In Pune",
        link: "/Honda-City-On-Rent-In-Pune",
    },
    {
        place: "/images/keyword/26.jpg",
        text: "Ertiga On Rent in Pune",
        link: "/Ertiga-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/27.jpg",
        text: "Innova Cab for Outstation in Pune",
        link: "/Innova-Cab-for-Outstation-in-Pune",
    },
];

  
const images = [
    { src: "/images/ourfleet/1.webp", alt: "Image 1" },
    { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

];

const schemaData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SHREE Tours & Travels",
  "description": "Book reliable and affordable outstation Cabs in Pune. We offer private and group outstation taxi services from Pune to popular destinations like Mahabaleshwar, Mumbai, Kolhapur and more. Call +91 9594917913 for booking!",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Your office address here",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "telephone": "+91-9594917913",
  "url": "https://shreetoursandtravels.in",
  "logo": "https://shreetoursandtravels.in/img/logo.jpg",
  "image": [
    "https://shreetoursandtravels.in/img/outstation-cabs-pune.jpg",
    "https://shreetoursandtravels.in/img/mahabaleshwar-outstation-cab.jpg"
  ],
  "priceRange": "₹2000 - ₹8000",
  "offers": {
    "@type": "Offer",
    "url": "https://shreetoursandtravels.in/outstation-cabs-pune",
    "priceCurrency": "INR",
    "price": 2500,
    "priceValidUntil": "2025-12-31"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": 4.7,
    "reviewCount": 1000
  },
  "review": [
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Ravi Kumar"
      },
      "datePublished": "2024-12-10",
      "reviewBody": "Fantastic experience! I booked an outstation Cab for a trip from Pune to Kolhapur. The driver was professional and the car was comfortable. Highly recommend SHREE Tours & Travels!"
    },
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Neha Patil"
      },
      "datePublished": "2024-12-15",
      "reviewBody": "The outstation Cab service from Pune to Mahabaleshwar was smooth and hassle-free. The ride was comfortable and the driver was punctual. Will definitely use it again!"
    }
  ],
  "serviceArea": {
    "@type": "Place",
    "name": "Outstation Cabs Service from Pune",
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 18.5204,  // Pune latitude
      "longitude": 73.8567  // Pune longitude
    }
  },
  "availableChannel": {
    "@type": "ServiceChannel",
    "serviceUrl": "https://shreetoursandtravels.in/outstation-cabs-pune"
  },
  "keywords": "Outstation Cabs in Pune, Pune to Outstation Taxi, Affordable Outstation Cab Service Pune, Private Outstation Cabs from Pune, Outstation Taxi Hire Pune, Pune to Mahabaleshwar Outstation Cab, Pune to Mumbai Outstation Taxi, Group Travel Outstation Cab Pune, Pune to Kolhapur Outstation Taxi, Book Outstation Cabs from Pune, Reliable Outstation Cabs Pune, Outstation Cab Rental Pune"
};





  return (
    <div>
      <GoogleAnalytics/>
    <Helmet>
  <title>Outstation Cabs Pune | SHREE Tours & Travels | Call: +91 9594917913</title>
  <meta name="description" content="Book reliable and affordable outstation Cabs in Pune. We offer private and group outstation taxi services from Pune to popular destinations like Mahabaleshwar, Mumbai, Kolhapur and more. Call +91 9594917913 for booking!" />
  <meta name="keywords" content="Outstation Cabs in Pune, Pune to Outstation Taxi, Affordable Outstation Cab Service Pune, Private Outstation Cabs from Pune, Outstation Taxi Hire Pune, Pune to Mahabaleshwar Outstation Cab, Pune to Mumbai Outstation Taxi, Group Travel Outstation Cab Pune, Pune to Kolhapur Outstation Taxi, Book Outstation Cabs from Pune, Reliable Outstation Cabs Pune, Outstation Cab Rental Pune" />
  <meta name="robots" content="index, follow" />
  <script type="application/ld+json">
    {JSON.stringify(schemaData)}
  </script>
</Helmet>
    <section
        className="page-title"
        style={{ backgroundImage: 'url(images/hero.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">{cardData.keyword} </h1>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
         <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/21.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#0310a8', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <div className='pb-3'>
                <button
                  className="p-3 text-white fw-bold borderrr bg-header"
                  onClick={() => {
                    window.location.href = '/booking';
                  }}
                >
                  Book Your Cab
                </button>
              </div>
              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
            <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for SHREE Tours & Travels </h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                {/* <CustomCarousel items={carouselItems} options={carouselOptions} /> */}

                <TestimonialKeyword testimonials={testimonialsData} />

                
              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
    {Images.map((e) => {
        return (
            <div className="box1">
                <a href={e.link} className="d-flex justify-content-around align-items-center">
                    <div className="b1">
                        <img src={e.place} alt="img" />
                    </div>
                    <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                    </div>
                </a>
            </div>
        );
    })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Fleet</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
               
                </div>
              </div>

             <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #0310a8',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#0310a8' }}>
                      <div>
                      <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>
                      
                      <div className=''>
                        <a href="tel:+919594917913" className="d-block  text-white">
                        <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 9594917913
                      </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:booking@shreecabs24.com" className=" text-white d-block">
                        <i className="fas fa-envelope darkcolorrr"></i> booking@shreecabs24.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                        <i className="fas fa-map-marker-alt darkcolorrr"></i>  SHREE Tours & Travels<br />
                          Maharashtra Co-Operative Housing Society,
                          Yerawada, Pune, Maharashtra India - 411006
                            
                         
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Outstationcabservice;